import { render, staticRenderFns } from "./brandTrainingRetailerTable.vue?vue&type=template&id=2f11697c&scoped=true"
import script from "./brandTrainingRetailerTable.vue?vue&type=script&lang=js"
export * from "./brandTrainingRetailerTable.vue?vue&type=script&lang=js"
import style0 from "./brandTrainingRetailerTable.vue?vue&type=style&index=0&id=2f11697c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11697c",
  null
  
)

export default component.exports